import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import { colors, defaultTextStyle } from 'settings/theme';

import Price from 'components/vistaprintUILibrary/Price';

function ProductSearchResult(props) {
  const {
    matchString,
    product,
    focused,
    onClick,
    onMouseEnter,
    id,
  } = props;

  const characters = [...matchString];

  const focusedStyle = {
    backgroundColor: colors.blueMid,
  };

  let boldMode = false;
  return (
    <button
      id={id}
      type="button"
      style={{
        // remove default button styles
        border: 'none',
        textAlign: 'left',
        width: '100%',
        backgroundColor: 'rgba(255,255,255,0)',

        boxSizing: 'border-box',

        ...defaultTextStyle,
        fontSize: '1.3em',
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 20,
        paddingRight: 20,
        cursor: 'pointer',
        ...(focused ? focusedStyle : []),

        display: 'flex',
        justifyContent: 'space-between',
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      <div
        style={{
          alignSelf: 'flex-start',
        }}
      >
        {characters.map((character, i) => {
          if (character === '<') {
            boldMode = true;
            return null;
          }

          if (character === '>') {
            boldMode = false;
            return null;
          }

          if (boldMode) {
            return (
              <span
                // eslint-disable-next-line react/no-array-index-key
                key={`${product.localizedName}-character-${i}`}
                style={{
                  fontWeight: 'bold',
                  color: focused ? colors.white : colors.blueMid,
                }}
              >
                {character}
              </span>
            );
          }
          return (
            <span
              // eslint-disable-next-line react/no-array-index-key
              key={`${product.localizedName}-character-${i}`}
              style={{
                color: focused ? colors.white : colors.textPrimary,
              }}
            >
              {character}
            </span>
          );
        })}
      </div>
      <Price
        style={{
          alignSelf: 'flex-end',
          color: focused ? colors.white : colors.textPrimary,
        }}
        priceHTML={product.localizedPriceHTML}
      />
    </button>
  );
}

ProductSearchResult.propTypes = {
  matchString: PropTypes.string.isRequired,
  product: PropTypes.shape({
    localizedName: PropTypes.string.isRequired,
    pfid: PropTypes.string.isRequired,
    localizedPriceHTML: PropTypes.string.isRequired,
  }).isRequired,
  focused: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default Radium(ProductSearchResult);



// WEBPACK FOOTER //
// ./src/components/ProductSearchResult.js